// extracted by mini-css-extract-plugin
module.exports = {"elementDecorator":"ExperiencePromoSection_elementDecorator__u2By_"};